import { render, staticRenderFns } from "./selectProductItem.vue?vue&type=template&id=0f0bb128&scoped=true&"
import script from "./selectProductItem.vue?vue&type=script&lang=js&"
export * from "./selectProductItem.vue?vue&type=script&lang=js&"
import style0 from "./selectProductItem.vue?vue&type=style&index=0&id=0f0bb128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0bb128",
  null
  
)

export default component.exports